@use "../../../../../../sedestral/sass/mixins/texts";

.componentWebsiteContentPricing {
  .title {
    text-align: center;
    //background: var(--grad-black);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;
    color: var(--white);
    font-size: 44px;

    @include texts.font("bold");
  }

  .offer {
    position: relative;
    width: 100%;
  }


  @media (max-width: 480px) {
    .title {
      font-size: 20px;
      width: 90%;
    }
  }
}